import type { FC, ReactNode } from 'react'
import type { LitToken } from '@/components/motion/lit-text'

import LitText from '@/components/motion/lit-text'
import { media } from '@/constants/media'

const TOKENS: Array<LitToken> = [
    'We make',
    { image: media.visorProfile, alt: "A model in wraparound sunglasses and a black shell jacket, in profile" },
    'essentials for people who refuse the ordinary. Fewer pieces, heavier',
    { image: media.elioLabelDetail, alt: "The Elio label inside a black shell beaded with rain" },
    'fabrics, longer lives — designed in Berlin, cut in Porto, worn everywhere after',
    { image: media.overcastSilhouette, alt: "A model in a black shell jacket silhouetted against a stormy sky" },
    'dark.'
]

const Manifesto: FC = (): ReactNode => {
    return (
        <section id='manifesto' className='relative bg-ink pb-28 pt-20 gutter md:pb-40 md:pt-32'>
            <div className='grid gap-10 md:grid-cols-12 md:gap-8'>
                <div className='md:col-span-3'>
                    <div className='flex items-center justify-between gap-4 md:sticky md:top-[calc(var(--header-height)+32px)] md:block'>
                        <p data-reveal='fade' className='label-mono text-acid'>
                            (01) — Manifesto
                        </p>

                        <p data-reveal='fade' data-reveal-delay='0.1' className='label-mono text-ash md:mt-3'>
                            Read slowly
                        </p>
                    </div>
                </div>

                <div className='md:col-span-9'>
                    <LitText
                        tokens={TOKENS}
                        className='font-sans text-[clamp(30px,4.3vw,68px)] font-medium leading-[1.04] tracking-[-0.035em] text-bone'
                    />

                    <div className='mt-14 flex items-center gap-5'>
                        <span data-reveal='line' aria-hidden='true' className='block h-px w-16 bg-acid' />

                        <p data-reveal='fade' className='serif-m text-bone'>
                            Mara Okonkwo, founder
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Manifesto
